import { FC, useId } from "react";
import styles from "./Support.module.scss";
import { Link } from "react-router-dom";
import Input from "@components/ui/input";
import { useForm } from "react-hook-form";

const Support: FC = () => {
    const nameId = useId();
    const telegramId = useId();
    const commentId = useId();
    const { register, handleSubmit } = useForm();

    return (
        <div className="container">
            <section className={styles.support}>
                {/* <div className={styles.header}>
                    <h1 className={styles.headline}>Support</h1>
                    <div className={styles.breadcrumb}>
                        <img width={16} height={16} src="/images/swap/home.svg" alt="" />
                        <img style={{ opacity: 0.5 }} width={12} height={12} src="/images/swap/right.svg" alt="" />
                        <Link to={"/support"}>SUPPORT</Link>
                    </div>
                </div> */}
                <div className={styles.content}>
                    <form onSubmit={handleSubmit((data) => console.log(data))} className={styles.form}>
                        <h2 className={styles.title}>Support</h2>
                        <label className={styles.label} htmlFor={nameId}>
                            <span>Your name</span>
                            <Input
                                register={register}
                                placeholder="Name"
                                type="text"
                                id={nameId}
                                required
                                name="name"
                            />
                        </label>
                        <label className={styles.label} htmlFor={telegramId}>
                            <span>Telegram username</span>
                            <Input
                                register={register}
                                placeholder="@username"
                                type="text"
                                id={telegramId}
                                required
                                name="telegram"
                            />
                        </label>
                        <label className={styles.label} htmlFor={commentId}>
                            <span>Comment</span>
                            <textarea
                                {...register("comment", { required: true })}
                                placeholder="Comment"
                                className={styles.textarea}
                                name="comment"
                                id={commentId}
                            />
                        </label>
                        <button type="submit" className={styles.button}>
                            Send a request
                        </button>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default Support;
